import {
    CLEAR_MINUTE_RENDER,
    FETCH_MINUTE_RENDER,
    LIST_MINUTE_RENDER
} from "./types";

const init = {
    isLoading: false,
    filter: {},
    draw: null,
    items: []
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_MINUTE_RENDER:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_MINUTE_RENDER:
            return {
                ...state,
                isLoading: false,
                draw: payload?.draw ?? null,
                items: payload?.items ?? []
            };
        case CLEAR_MINUTE_RENDER:
            return {
                ...init
            };
        default:
            return state;
    }
}
